routing.$inject = ['$stateProvider'];

export default function routing($stateProvider) {
    $stateProvider
        .state('subscriber.groups', {
            url: '/groups',
            controller: 'CustomizationCtrl',
            controllerAs: 'index',
            template: require('../../../views/customize/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:GROUPS',
                parent: 'subscriber.index'
            }
        })

        .state('subscriber.group', {
            url: '/groups/{id}',
            controller: 'CustomGroupShowCtrl',
            controllerAs: 'show',
            template: require('../../../views/customize/show.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:GROUP',
                parent: 'subscriber.groups'
            }
        })
}